module.exports = __webpack_public_path__ + "img/flask.4af43d12.svg";